import React from 'react';
import 'twin.macro';
import { useDemarrage } from 'containers/Demarrage/queries/useDemarrage';
import { useNavigate } from 'react-router-dom';
import { FREcoleStep } from './FREcole';
import { USEcoleStep } from './USEcole';
import { AUEcoleStep } from './AUEcole';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';

export function EcoleStep() {
  const navigate = useNavigate();
  const user = useUser();
  const { data: demarrageData } = useDemarrage();
  const onManual = () => navigate('/demarrage/ecole-details');
  if (!demarrageData) {
    return null;
  }
  const userCountryCode = demarrageData.userCountryCode || user.country || 'FR';
  if (userCountryCode === 'US') {
    return <USEcoleStep demarrageData={demarrageData} onManual={onManual} />;
  }
  if (userCountryCode === 'AU') {
    return <AUEcoleStep demarrageData={demarrageData} onManual={onManual} />;
  }
  return <FREcoleStep demarrageData={demarrageData} onManual={onManual} />;
}
